import { render, staticRenderFns } from "./ManagerList.vue?vue&type=template&id=631b5018&"
import script from "./ManagerList.vue?vue&type=script&lang=js&"
export * from "./ManagerList.vue?vue&type=script&lang=js&"
import style0 from "./ManagerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports